import React, { useState, useContext, useRef, useEffect } from 'react';
import { useAtom } from 'jotai';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import { isAuthAtom, dataUserAtom, setDataUserAtom } from '../../Services/store/atoms';
import config from '../../Config';
import DarkModeContext from '../../Components/DarkModeContext';
import Modal from '../../Components/Modal';
import ModalActions from '../../Components/ModalActions';
import DateOfBirthSelector from '../../Components/DateOfBirthSelector';
import { FaVenusMars, FaSpinner } from 'react-icons/fa';
import { FaHeart } from 'react-icons/fa6';
import { LuVenetianMask } from 'react-icons/lu';
import useNicknameAvailability from '../../hooks/useNicknameAvailability';

function ClientCompleteProfile() {
    const history = useHistory();
    const [isAuth] = useAtom(isAuthAtom);
    const [dataUser] = useAtom(dataUserAtom);
    const [, setDataUser] = useAtom(setDataUserAtom);
    const { darkMode } = useContext(DarkModeContext);
    const modalRef = useRef(null);

    const [nickname, setNickname] = useState('');
    const [nicknameV, setNicknameV] = useState(false);
    const [gender, setGender] = useState('');
    const [genderV, setGenderV] = useState(false);
    const [interestedIn, setInterestedIn] = useState('');
    const [interestedInV, setInterestedInV] = useState(false);
    const [birthdate, setBirthdate] = useState('');
    const [birthdateV, setBirthdateV] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const nicknameStatus = useNicknameAvailability(nickname);

    useEffect(() => {
        if (!isAuth || dataUser.role !== 'client') {
            history.push('/');
            return;
        }
        if (dataUser.nickname && dataUser.gender && dataUser.interested_in) {
            history.push('/client');
        }
    }, [isAuth, dataUser, history]);

    const validate = (field) => {
        if (field) return "animate__animated animate__flash border-2 border-rose-500";
    };

    const submitCompleteProfile = () => {
        let message = "";

        if (!dataUser.nickname) {
            if (!nickname) { setNicknameV(true); message += "Elige un nickname -"; }
            else if (nicknameStatus !== 'available') { setNicknameV(true); message += "Ese nickname no está disponible -"; }
        }
        if (!gender) { setGenderV(true); message += "Selecciona tu género -"; }
        if (!interestedIn) { setInterestedInV(true); message += "Selecciona tu interés -"; }
        if (!birthdate) { setBirthdateV(true); message += "Selecciona tu fecha de nacimiento -"; }

        if (message !== "") return;

        setIsLoading(true);
        axios.post(`${config.REACT_APP_BASE_URL}/api/v1/auth/complete-client-profile`, {
            ...(nickname ? { nickname } : {}),
            gender,
            interested_in: interestedIn,
            Birthdate: birthdate,
        })
            .then(function () {
                setIsLoading(false);
                setDataUser({ ...dataUser, ...(nickname ? { nickname } : {}), gender, interested_in: interestedIn, birthdate });
                history.push('/client');
            })
            .catch(function (error) {
                setIsLoading(false);
                const errMsg = error.response?.data?.message || 'Error al actualizar el perfil';
                modalRef.current.openModal(
                    'error', errMsg,
                    <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-500'}`}>
                        {error.response?.data?.errors ? Object.values(error.response.data.errors).flat().join(', ') : errMsg}
                    </p>,
                    <ModalActions onClose={() => modalRef.current.closeModal()} />
                );
            });
    };

    return (
        <>
            <div className="flex justify-center pt-10">
                <div className={`w-full rounded-xl md:mt-1 sm:max-w-md ${darkMode ? 'bg-gray-800' : 'bg-white'} shadow-sm`}>
                    <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                        <h1 className={`text-xl font-semibold text-center ${darkMode ? 'text-rose-500' : 'text-rose-500'}`}>
                            Completa tu perfil
                        </h1>
                        <p className={`text-sm text-center ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            Cuéntanos tu género y a quién te interesa ver para armar tu feed.
                        </p>
                        <div className="flex flex-col space-y-3 md:space-y-4">
                            {!dataUser.nickname && (
                                <>
                                    <div className={`${darkMode ? 'bg-gray-700' : 'bg-white'} p-2 rounded-[10px] shadow flex flex-row ${validate(nicknameV)} h-full`}>
                                        <LuVenetianMask className={`mt-1 ${darkMode ? 'text-white' : 'text-gray-500'}`} />
                                        <input
                                            type="text"
                                            value={nickname}
                                            onChange={(e) => { const v = e.target.value.replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, ''); setNickname(v); setNicknameV(false); }}
                                            placeholder="Nickname"
                                            className={`ml-4 ${darkMode ? 'bg-gray-700 text-white' : 'bg-white text-black'} border-transparent focus:border-transparent focus:ring-0 flex-grow flex-shrink h-full`}
                                            disabled={isLoading}
                                        />
                                    </div>
                                    {nicknameV && <div className="text-red-500 text-sm ml-4">Elige un nickname</div>}
                                    {!nicknameV && nickname && nicknameStatus === 'checking' && (
                                        <div className="text-gray-400 text-sm ml-4">Comprobando disponibilidad...</div>
                                    )}
                                    {!nicknameV && nickname && nicknameStatus === 'available' && (
                                        <div className="text-green-500 text-sm ml-4">Nickname disponible</div>
                                    )}
                                    {!nicknameV && nickname && nicknameStatus === 'taken' && (
                                        <div className="text-red-500 text-sm ml-4">Ese nickname ya está en uso</div>
                                    )}
                                </>
                            )}

                            <div className={`${darkMode ? 'bg-gray-700' : 'bg-white'} p-2 rounded-[10px] shadow flex flex-row ${validate(genderV)} h-full`}>
                                <FaVenusMars className={`mt-1 ${darkMode ? 'text-white' : 'text-gray-500'}`} />
                                <select
                                    aria-label="Tu género"
                                    value={gender}
                                    onChange={(e) => { setGender(e.target.value); setGenderV(false); }}
                                    className={`ml-4 ${darkMode ? 'bg-gray-700 text-white' : 'bg-white text-black'} border-transparent focus:border-transparent focus:ring-0 flex-grow flex-shrink h-full ${!gender ? 'text-gray-400' : ''}`}
                                    disabled={isLoading}
                                    style={{ appearance: 'none', WebkitAppearance: 'none', MozAppearance: 'none' }}
                                >
                                    <option value="" disabled hidden>Selecciona tu género</option>
                                    <option value="female">Soy mujer</option>
                                    <option value="male">Soy hombre</option>
                                    <option value="trans">Soy trans</option>
                                </select>
                            </div>
                            {genderV && <div className="text-red-500 text-sm ml-4">Selecciona tu género</div>}

                            <div className={`${darkMode ? 'bg-gray-700' : 'bg-white'} p-2 rounded-[10px] shadow flex flex-row ${validate(interestedInV)} h-full`}>
                                <FaHeart className={`mt-1 ${darkMode ? 'text-white' : 'text-gray-500'}`} />
                                <select
                                    aria-label="Estoy interesado en"
                                    value={interestedIn}
                                    onChange={(e) => { setInterestedIn(e.target.value); setInterestedInV(false); }}
                                    className={`ml-4 ${darkMode ? 'bg-gray-700 text-white' : 'bg-white text-black'} border-transparent focus:border-transparent focus:ring-0 flex-grow flex-shrink h-full ${!interestedIn ? 'text-gray-400' : ''}`}
                                    disabled={isLoading}
                                    style={{ appearance: 'none', WebkitAppearance: 'none', MozAppearance: 'none' }}
                                >
                                    <option value="" disabled hidden>Estoy interesado en...</option>
                                    <option value="female">Mujeres</option>
                                    <option value="male">Hombres</option>
                                    <option value="both">Ambos</option>
                                </select>
                            </div>
                            {interestedInV && <div className="text-red-500 text-sm ml-4">Selecciona tu interés</div>}

                            <div autoComplete="new-password">
                                <DateOfBirthSelector
                                    onDateChange={(date) => { setBirthdate(date); setBirthdateV(false); }}
                                    darkMode={darkMode}
                                />
                            </div>
                            {birthdateV && <div className="text-red-500 text-sm ml-4">Selecciona tu fecha de nacimiento</div>}

                            <button
                                onClick={submitCompleteProfile}
                                className={`w-full text-white bg-rose-500 hover:bg-rose-700 focus:outline-none font-medium rounded-full text-sm px-5 py-2.5 text-center ${isLoading ? 'cursor-not-allowed opacity-70' : ''}`}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <FaSpinner className="animate-spin mx-auto" />
                                ) : (
                                    'Continuar'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal ref={modalRef} />
        </>
    );
}

export default ClientCompleteProfile;
